<mat-tab-group igClickStopPropagation class="mt-4" (selectedIndexChange)="switchTab($event)">
  <mat-tab label="Your Photos" class="cursor-pointer">
    <div class="relative">
      <img *ngIf="initialImg && !selectedImageFile" [src]="initialImg" class="mb-4 w-[74%] ml-[13%] pt-4" alt=""
        (click)="imageSelector.click()" (load)="isLoaded=true">
      <img *ngIf="!initialImg && !selectedImageFile" src="https://iti-images.s3.us-east-1.amazonaws.com/imgs/upload.jpg"
        class="mb-4 w-[74%] ml-[13%]" alt="" (load)="isLoaded=true" (click)="imageSelector.click()">
      <img *ngIf="selectedImageFile" [src]="selectedImageData" class="my-4 w-[74%] ml-[13%]" alt=""
        (click)="imageSelector.click()">

      @if ((initialImg || selectedImageFile) && isLoaded) {
      <div class="w-[74%] ml-[13%] flex flex-col gap-2 text-cover-image">
        <span (click)="imageSelector.click()">
          Click to update image
        </span>
        <span [class.ig-hide]="!isAllowRemove" class="!text-xs !cursor-default">or</span>
        <span [class.ig-hide]="!isAllowRemove" [matMenuTriggerFor]="deleteMenu" #menuTrigger="matMenuTrigger"
          class="!text-base">
          Remove image
        </span>

        <mat-menu #deleteMenu="matMenu" class="ig-confirm-menu !p-3">
          <div class="flex flex-col gap-2">
            <p class="text-sm font-medium">
              <mat-icon class="text-red-400 translate-y-1.5 mr-1">warning</mat-icon>
              Are you sure you want to remove the background image?
            </p>
            <div class="flex gap-2 justify-end">
              <button mat-menu-item
                class="!text-sm !bg-red-400 !text-white !w-[100px] !text-center !rounded-[4px] !min-h-[unset] !h-8 !mt-2"
                (click)="removeBgImg()">DELETE</button>
              <button mat-menu-item
                class="!text-gray-600 !bg-gray-200 !text-center !min-h-[unset] !h-8 !w-[100px] !mt-2 !rounded-sm"
                (click)="menuTrigger.closeMenu();$event.stopPropagation()">CANCEL</button>
            </div>
          </div>
        </mat-menu>
      </div>
      }

    </div>

    <p class="text-gray-600 text-sm">
      Please upload image in JPG, PNG or WEBP format. Landscape image recommended</p>

    <input type="file" class="invisible h-0" accept="image/png,image/webp,image/jpeg" #imageSelector
      (change)="onImageChange($event)">

  </mat-tab>

  <mat-tab label="Paste Image Link">
    <ig-field label="Image Url" icon="image" class="mt-8 block" [control]="form.get('imageLink')"
      (onInputChange)="imageLinkChange($event)" [hint]="imageLinkErrorMsg"></ig-field>
  </mat-tab>

</mat-tab-group>

<div #copyRights>
  <mat-checkbox *ngIf="showCopyRights" [(ngModel)]="hasCopyrights" igClickStopPropagation
    class="mb-2 border-red-400 rounded-md transition-all duration-150" [class.border-2]="isShowCopyRightsAlert">
    Please note that any images uploaded or used in this software must either be royalty-free
    or owned by the client. By uploading or using an image, you
    acknowledge that you have the necessary rights to use it and that you will be solely responsible for any
    copyright infringement or other legal issues that may arise from the use of the image. We strongly advise our
    users to exercise due diligence and ensure that they have the necessary rights to use any images uploaded or
    used in this software.
  </mat-checkbox>
  <ig-button *ngIf="useUploadButton" [disabled]="(selectedImageFile||imageLink)&&!hasCopyrights"
    class="mt-4 mb-1 w-full block" cls="w-full" igClickStopPropagation successText="Image updated!"
    (trigger)="submit($event)" [isAsync]="true">Upload Image
  </ig-button>
</div>